//
// Notification for search widget result
// -------------------------------------

define(function(require) {
    'use strict';

    var _ = require('underscore');
    var core = require('core');
    var storage = require('util/storage.util');
    var user = require('user');
    var launcher = require('modules/launcher/launcher');

    return {
        notify: function(obj) {
            switch (obj.data.type) {
                case 'game':
                    var cachedGames = storage.local.getItem('searchWidgetStorage') || {};
                    var games = cachedGames[user.get('userName')] || [];
                    var newGame = obj.data.result;
                    var item = {};

                    !_.findWhere(games, { 'gameCode': newGame.gameCode }) && games.unshift(newGame);
                    item[user.get('userName')] = games.splice(0, 5);
                    user.isLoggedIn() && storage.local.setItem('searchWidgetStorage', _.extend(cachedGames, item));

                    var params = {
                        gameCode: newGame.gameCode,
                        container: 'Search'
                    };

                    core.trigger('game:launch:maybe', params);

                    // launch game in real mode
                    launcher.launchGame(newGame.gameCode, 1, newGame.additionalQueryString);
                    break;
            }

            return this;
        }
    };
});
